// @flow

import React, {Component} from 'react'
import {connect} from 'react-redux'
import {map, mergeAll, propEq, filter} from 'ramda'
import {appActions, appSelectors, portfoliosSelectors, uiActions} from '@/store'
import DropdownSelector from './dropdown-selector'
import {isSharedPortfolio} from '@/views/util'

import './portfolio-select.css'
import type {Language} from '../types'

type Props = {
  activePortfolioId: ?number,
  changeActivePortfolio: (number) => void,
  l: Language,
  portfolios: Array<Object>,
  isActivePortfolioShared: boolean,
  activeTab: string,
}

const toOption = (l) => (portfolio) => {
  const isShared = isSharedPortfolio(portfolio)
  return {
    key: portfolio.portfolioId,
    value: (portfolio.name) + (portfolio.isDefault && !isShared ? `(${l('default')})` : ''),
    isShared,
    isAllPortfolio: portfolio.isAllPortfolio ? portfolio.isAllPortfolio : false,
  }
}

const getTranslatedPortfolioName = (portfolioName, l) => portfolioName === 'All Portfolios'
  ? l(portfolioName) : portfolioName

const getSelectedPortfolioName = (id: string, portfolios, l) => {
  let selectedPortfolio = filter(propEq('portfolioId', parseInt(id, 10)), portfolios)
  return selectedPortfolio.length > 0
    ? getTranslatedPortfolioName(selectedPortfolio[0].name, l) +
      (selectedPortfolio[0].isDefault && !isSharedPortfolio(selectedPortfolio[0]) ? ` (${l('default')})` : '') : ''
}

export class RawPortfolioSelect extends Component<Props> {
  handlePortfolioChange = (newId: string) => {
    this.props.changeActivePortfolio(parseInt(newId, 10))
  }

  render () {
    const {
      activePortfolioId,
      portfolios,
      isActivePortfolioShared,
      l,
    } = this.props

    const options = map(toOption(l), portfolios)
    const notAllPortfoliosTabs = ['exports', 'settings']
    if (notAllPortfoliosTabs.includes(this.props.activeTab)) {
      options.shift()
    }
    return (
      <div className="portfolio-select">
        <DropdownSelector
          label=""
          selected={getSelectedPortfolioName(String(activePortfolioId), portfolios, l)}
          isShared={isActivePortfolioShared}
          options={options}
          onChange={this.handlePortfolioChange}
          activeId={activePortfolioId}
          defaultText = 'Select portfolio'
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
  activePortfolioId: appSelectors.getActivePortfolioId(state),
  portfolios: portfoliosSelectors.getPortfolios(state),
  isActivePortfolioShared: portfoliosSelectors.isActivePortfolioShared(state),
  activeTab: state.ui.activeTab,
})

export default connect(
  mapStateToProps,
  mergeAll([appActions, uiActions]),
)(RawPortfolioSelect)



// WEBPACK FOOTER //
// ./src/controls/portfolio-select.js